import { render, staticRenderFns } from "./StepColumnMapping.vue?vue&type=template&id=cfd08dc4&scoped=true"
import script from "./StepColumnMapping.vue?vue&type=script&lang=js"
export * from "./StepColumnMapping.vue?vue&type=script&lang=js"
import style0 from "./StepColumnMapping.vue?vue&type=style&index=0&id=cfd08dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd08dc4",
  null
  
)

export default component.exports